import React from 'react';
import HeroTemplate from '../components/HeroTemplate';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, Users, Heart, CheckCircle, TrendingUp, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
const PoliceRcdSolidaire = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navigation />      {/* Bouton Retour */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/aides-solidaires" label="Retour aux Aides Solidaires" />
      </div>

      {/* Hero Section avec l'image */}
      <HeroTemplate
        backgroundImage="/templates/police-rcd-solidaire.svg"
        title="Garantie solidaire RCD SOLIDAIRE"
        subtitle="Dispositif de Protection"
        description="Une Responsabilité Civile Décennale solidaire et accessible pour tous les professionnels du BTP"
        ctaText="Estimer mon tarif"
        ctaLink="/calculateur-batico"
        height="600px"
        overlay={true}
        overlayOpacity={0.4}
      />

      {/* Section Introduction */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Qu'est-ce que la Garantie solidaire RCD SOLIDAIRE ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un dispositif innovant de responsabilité décennale basé sur la solidarité entre professionnels, 
            offrant une protection complète à des tarifs accessibles.
          </p>
        </div>

        {/* Cards des avantages */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all duration-300 hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <Shield className="h-6 w-6 text-blue-600" />
              </div>
              <CardTitle>Protection Complète</CardTitle>
              <CardDescription>
                Responsabilité Civile Décennale avec des plafonds adaptés à votre activité
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Plafond avant livraison : jusqu'à 15M€</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Plafond décennale : jusqu'à 30M€</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Franchises adaptées par type de dommage</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2 border-green-100 hover:border-green-300 transition-all duration-300 hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-green-600" />
              </div>
              <CardTitle>Solidarité</CardTitle>
              <CardDescription>
                Un système basé sur l'entraide entre professionnels du bâtiment
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Mutualisation des risques</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Accompagnement entre pairs</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Réseau de professionnels solidaires</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2 border-purple-100 hover:border-purple-300 transition-all duration-300 hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                <Heart className="h-6 w-6 text-purple-600" />
              </div>
              <CardTitle>Accessibilité</CardTitle>
              <CardDescription>
                Des tarifs adaptés calculés selon votre chiffre d'affaires
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Tarification transparente et juste</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Calcul basé sur votre CA</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Pas de surprime selon profil</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* Section Garanties */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <FileText className="h-6 w-6 text-blue-600 mr-3" />
            Garanties Principales
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-lg text-gray-800 mb-3">
                Responsabilité Civile Décennale (RCD)
              </h4>
              <ul className="space-y-2 text-gray-600">
                <li>• Dommages compromettant la solidité de l'ouvrage</li>
                <li>• Dommages le rendant impropre à sa destination</li>
                <li>• Dommages affectant les éléments d'équipement</li>
                <li>• Protection pendant 10 ans après réception</li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-lg text-gray-800 mb-3">
                Couverture Avant Livraison
              </h4>
              <ul className="space-y-2 text-gray-600">
                <li>• Dommages pendant les travaux</li>
                <li>• Protection jusqu'à la réception des travaux</li>
                <li>• Plafond jusqu'à 15 millions d'euros</li>
                <li>• Franchise adaptée selon nature du dommage</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section Processus */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Comment Souscrire ?
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { 
                step: '1', 
                title: 'Estimation du tarif', 
                desc: 'Utilisez notre estimateur solidaire BATICO pour obtenir votre tarif personnalisé',
                icon: TrendingUp
              },
              { 
                step: '2', 
                title: 'Adhésion', 
                desc: 'Rejoignez la coopérative via votre COOPER\'S référent',
                icon: Users
              },
              { 
                step: '3', 
                title: 'Validation', 
                desc: 'Signature électronique et validation des documents',
                icon: FileText
              },
              { 
                step: '4', 
                title: 'Protection active', 
                desc: 'Recevez votre attestation et bénéficiez de la couverture',
                icon: Shield
              }
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="relative">
                  <div className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-2xl transition-shadow duration-300">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon className="h-8 w-8 text-blue-600" />
                    </div>
                    <div className="text-3xl font-bold text-blue-600 mb-2">
                      {item.step}
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-2">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {item.desc}
                    </p>
                  </div>
                  {index < 3 && (
                    <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-0.5 bg-blue-200" />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA Final */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Prêt à Protéger Votre Activité ?
          </h3>
          <p className="text-xl mb-8 opacity-90">
            Calculez votre tarif personnalisé en quelques clics
          </p>
          <Button
            onClick={() => window.location.href = '/calculateur-batico'}
            size="lg"
            className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg font-semibold rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300"
          >
            Calculer mon tarif maintenant
          </Button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PoliceRcdSolidaire;
